const LEAVE_TYPES = ['休假', '傷病假', '公假', '事假', '婚假', '產檢假', '產假', '公傷假', '喪假', '育嬰假']

export {
  LEAVE_TYPES,
}
